import MonitioringStationView from "../views/MonitoringStationView.vue";
import MonitioringStationGraphView from  "../views/MonitioringStationGraphView.vue";
//import MonitoringBaseStationsView from "../views/MonitoringBaseStationsView.vue";
import { optionsStore } from "@/store/options";
export default {
  path: "/monitoring",
  name: "MonitoringPage",
  redirect: { name: "MonitoringMap" },
  children: [
    {
      path: ":basestation",
      name: "MonitoringStation",
      params: true,
      props: {
        // You must set `true` to the default view, which uses StationDetail
        default: true,
      },
      component: MonitioringStationView,
      meta: {
        requiresAuth: true,
        roles: ["ADMIN", "INSTALLER"],
      },
      beforeEnter: (to, from, next) => {
        //TOREMOVE when single api is added
        console.log(from);
        optionsStore.state.navigation.prewView=from.path
        console.log(optionsStore.state.navigation.prewView);
        if (from.name != "MonitoringMap") {
          let pathbs = localStorage.getItem(to.params.basestation);
          // console.log(pathbs);
          if (pathbs == null || pathbs == undefined) {
            return next({ name: "MonitoringMap" });
          }
        }
        return next();
      },
      beforeDestroy: (to, from, next) => {
        console.log(from + " => " + to);
        localStorage.removeItem("station");
        localStorage.removeItem("baseStationId");
        return next();
      },
    },
    
    {
      path: ":basestation/graph",
      name: "MonitioringStationGraphView",
      params: true,
      props: {
        default: true,
      },
      component: MonitioringStationGraphView,
      meta: {
        requiresAuth: true,
        roles: ["ADMIN", "INSTALLER"],
      },
    },
    
  ],
  meta: {
    requiresAuth: true,
    roles: ["ADMIN", "INSTALLER"],
  },
  beforeEnter: (to, from, next) => {
    return next();
  },
};
